import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { LEGISLATION_FILES, LegislationFileDescriptor } from '../legislation-files';

@Component({
  selector: 'app-legislation-list',
  templateUrl: './legislation-list.component.html',
  styleUrls: ['./legislation-list.component.sass'],

})

export class LegislationListComponent implements OnInit {
  private readonly allFiles: LegislationFileDescriptor[] = LEGISLATION_FILES;

  arquivos: LegislationFileDescriptor[] = [];
  filtro: string = '';
  currentPage: number = 1;
  filesPerPage: number = 5;

  length = this.arquivos.length;
  pageSize = 10;
  pageIndex = 0;
  pageSizeOptions = [10];

  showPageSizeOptions = false;
  showFirstLastButtons = false;
  disabled = false;

  pageEvent!: PageEvent;

  handlePageEvent(e: PageEvent) {
    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;
  }

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    if (setPageSizeOptionsInput) {
      this.pageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);
    }
  }

  constructor() {}

  @ViewChild(MatPaginator, {static : true}) paginator!: MatPaginator;
  ngOnInit(): void {
    this.uploadFiles();

  }

  uploadFiles(){
    const normalizedFilter = this.filtro.trim().toLowerCase();
    this.arquivos = normalizedFilter
      ? this.allFiles.filter(({ title }) =>
          title.toLowerCase().includes(normalizedFilter)
        )
      : this.allFiles;
    this.length = this.arquivos.length;
  }

  search(){
    this.uploadFiles();
    this.pageIndex = 0;
    this.changePage(this.pageIndex);
    this.paginator.firstPage();
    this.length = this.arquivos.length;
  }

  clean(){
    this.filtro = '';
    this.uploadFiles();
  }

  get filesPaginated(): LegislationFileDescriptor[] {
    const first = this.pageIndex * this.pageSize;
    const end = first + this.pageSize;
    return this.arquivos.slice(first, end);
  }

  changePage(newPage: number){
    this.currentPage = newPage;
  }

}
